<div class="sidebar-picker-body">
  <div class="picker-search-row">
    <soft-ds-search-input #searchInput
                          class="sidebar-picker-search"
                          size="md"
                          [value]="searchText()"
                          (valueChange)="onSearchValue($event)"
                          (keydown)="onSearchKeydown($event)"
                          [placeholder]="'#CORE_FILTER.MULTI_SELECT.SEARCH' | translate"
                          data-testid="page-filter-picker-search" />
    <soft-ds-toggle-group class="picker-only-selected"
                          size="md"
                          variant="outline"
                          mode="multiple"
                          [value]="selectedView()"
                          (valueChange)="onOnlySelectedChange($event)"
                          [disabled]="selectedCount() === 0"
                          data-testid="page-filter-only-selected">
      <soft-ds-toggle value="selected"
                      icon="fa-regular fa-square-check"
                      hideLabel
                      [label]="onlySelectedLabel()" />
    </soft-ds-toggle-group>
  </div>
  <div
    #pickerList
    class="sidebar-picker-list"
    role="listbox"
    [id]="listboxId()"
    aria-multiselectable="true"
    tabindex="-1"
    (scroll)="onScroll($event)"
  >
    @if (nothingSelected()) {
      <soft-ds-empty-state variant="empty"
                           size="sm"
                           [title]="'#CORE_FILTER.MULTI_SELECT.NOTHING_SELECTED_TITLE' | translate"
                           [description]="'#CORE_FILTER.MULTI_SELECT.NOTHING_SELECTED_DESCRIPTION' | translate"
                           [actionLabel]="'#CORE_FILTER.MULTI_SELECT.SHOW_ALL' | translate"
                           (action)="onOnlySelectedChange([])"
                           data-testid="page-filter-nothing-selected" />
    } @else if (onlySelected()) {
      <div class="sidebar-picker-options">
        @for (value of selectedForDisplay(); track value; let i = $index) {
          @let label = $any(item().formatter)($any(value));
          <soft-ds-select-option
            class="sidebar-picker-row"
            [class.is-highlighted]="highlightedIndex() === i"
            [class.is-empty-value]="!(label | isDefinedNotEmpty)"
            [value]="value"
            [label]="(label | isDefinedNotEmpty) ? label : ('#CORE_FILTER.MULTI_SELECT.EMPTY_VALUE' | translate)"
            [attr.data-option-index]="i" />
        }
      </div>
      @if (selectedForDisplay().length === 0) {
        <soft-ds-empty-state variant="empty"
                             size="sm"
                             [description]="'#CORE_FILTER.MULTI_SELECT.NO_VALUES' | translate"
                             data-testid="page-filter-values-empty" />
      }
    } @else if (loadFailed() && values().length === 0) {
      <soft-ds-empty-state variant="error"
                           size="sm"
                           [title]="'#CORE_FILTER.LOAD_ERROR' | translate"
                           [description]="loadErrorDetail()"
                           [actionLabel]="'#CORE_FILTER.RETRY' | translate"
                           (action)="retry()"
                           data-testid="page-filter-values-error" />
    } @else if (values().length === 0 && loading()) {
      <div class="sidebar-picker-options" aria-live="polite" data-testid="page-filter-values-skeleton">
        @for (row of loadingRows(); track row) {
          <soft-ds-loading-skeleton
            width="100%"
            height="var(--ds-select-option-height)"
            radius="var(--ds-select-option-radius)"
          />
        }
      </div>
    } @else {
      <div class="sidebar-picker-options">
        @for (value of values(); track value; let i = $index) {
          @if(value | isDefinedNotEmpty) {
            @let label = $any(item().formatter)($any(value));
            <soft-ds-select-option
              class="sidebar-picker-row"
              [class.is-highlighted]="highlightedIndex() === i"
              [class.is-empty-value]="!(label | isDefinedNotEmpty)"
              [value]="value"
              [label]="(label | isDefinedNotEmpty) ? label : ('#CORE_FILTER.MULTI_SELECT.EMPTY_VALUE' | translate)"
              [attr.data-option-index]="i" />
          }
        }
      </div>
      @if (values().length === 0 && !loading()) {
        <soft-ds-empty-state variant="empty"
                             size="sm"
                             [description]="'#CORE_FILTER.MULTI_SELECT.NO_VALUES' | translate"
                             [actionLabel]="hasMore() ? ('#CORE_FILTER.LOAD_MORE' | translate) : null"
                             (action)="loadMorePages()"
                             data-testid="page-filter-values-empty" />
      }
      @if (loadFailed() && values().length > 0) {
        <div class="sidebar-picker-page-error" aria-live="polite" data-testid="page-filter-values-page-error">
          <span class="ds-caption">{{ '#CORE_FILTER.LOAD_ERROR' | translate }}</span>
          <soft-ds-button variant="ghost" size="sm" (click)="retry()">
            {{ '#CORE_FILTER.RETRY' | translate }}
          </soft-ds-button>
        </div>
      }
      @if (loading()) {
        <div class="flex justify-center py-2" aria-live="polite">
          <soft-loading-spinner />
        </div>
      }
    }
  </div>
</div>
